<ion-content>
  <div class="widget-container">
    <ion-grid>
      <!-- Header Row with Radio Buttons -->
      <ion-row class="header-row">
        <ion-col size="10">
          <ion-label class="header-title">{{ 'Performance Level Rating' | translate}}</ion-label>
        </ion-col>
        <ion-col
        size="2" class ="header-col">

  <!-- Radio Group -->
      <ion-radio-group
      #screenModeGroup
     [value]="screenMode"
     (ionChange)="onScreenModeChange($event)"
     class="radio-inline-group">

    <!-- Graph -->
    <ion-item lines="none" class="radio-item">
      <ion-radio
        #graphModeRadio
        (keydown.shift.tab)="handleRadioShiftTab($event)"
        slot="start"
        value="graph"
        color="primary">
      </ion-radio>

      <ion-label
        [ngClass]="{ 'active-label': screenMode === 'graph' }">
        {{ 'plr_from_graph' | translate }}
      </ion-label>
    </ion-item>

    <!-- Manual -->
    <ion-item lines="none" class="radio-item">
      <ion-radio
        #manualModeRadio
        (keydown.shift.tab)="handleRadioShiftTab($event)"
        slot="start"
        value="manual"
        color="primary">
      </ion-radio>

      <ion-label
        [ngClass]="{ 'active-label': screenMode === 'manual' }">
        {{ 'enter_plr_value' | translate }}
      </ion-label>
    </ion-item>

  </ion-radio-group>

  <!-- Close Icon -->
  <img
    tooltip="{{'Close' | translate }}"
    alt="Close"
    placement="bottom"
    src="../../../assets/icon/cancel.svg"
    (click)="close()"
    class="close-icon">

</ion-col>
      </ion-row>

      <!-- Screen 1: PLR from Graph (EXISTING) -->
      <ion-row class="content-row" *ngIf="screenMode === 'graph'">
        <ion-col size="6">
          <ion-row class="cr-row">
            <ion-col size="12">
              <ion-label class="crr-label"> {{ 'Severity' | translate}} *</ion-label>
              <div class="crr-ng-bottom-marg">
                <ng-select name="severity" placeholder="{{'Select'|translate}}" [items]="severityList" [clearable]="false"
                  bindValue="val" bindLabel="name" (change)="calculatePlrValue()"
                  [(ngModel)]="selectedPlrList.severity">
                </ng-select>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="cr-row">
            <ion-col size="12">
              <ion-label class="crr-label"> {{ 'Frequency of Exposure' | translate}} *</ion-label>
              <div class="crr-ng-bottom-marg">
                <ng-select name="freqExpo" placeholder="{{'Select'|translate}}" [items]="frequencyExposureList" [clearable]="false"
                  bindValue="val" bindLabel="name" (change)="calculatePlrValue()"
                  [(ngModel)]="selectedPlrList.freqExpo">
                </ng-select>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="cr-row">
            <ion-col size="12">
              <ion-label class="crr-label"> {{ 'Possibility of Avoidance' | translate}} *</ion-label>
              <div class="crr-ng-bottom-marg">
                <ng-select name="posOfAvoidance" placeholder="{{'Select'|translate}}" [items]="possibilityOfAvoidanceList"
                  [clearable]="false" bindValue="val" bindLabel="name" (change)="calculatePlrValue()"
                  [(ngModel)]="selectedPlrList.posOfAvoidance">
                </ng-select>
              </div>
            </ion-col>
          </ion-row>

          <!-- NEW: Description Field (Read-only) -->
         <!-- Description Field (Read-only, multi-line) -->
           <ion-row class="cr-row">
            <ion-col size="12">
              <ion-label class="crr-label">
                 {{ 'Description' | translate }}
              </ion-label>
               <div class="crr-ng-bottom-marg">
              <ion-card tabindex="-1" class=" align scrollVertical">
        <div  class="description-container" [innerHTML]="descriptionValue" > </div>
        </ion-card>
                </div>
           </ion-col>
          </ion-row>

          <ion-row class="cr-row">
            <ion-col size="6">
              <ion-label  class="crr-label"> {{ 'Performance Level Rating' | translate}}</ion-label>
              <div class="crr-ng-bottom-marg">
                <ion-input tabindex="-1" readonly value={{plr_value}} placeholder=""></ion-input>
              </div>
            </ion-col>

            <ion-col size="6">
              <ion-label class="crr-label"> {{ 'Category' | translate}}</ion-label>
              <div class="crr-ng-bottom-marg">
                <ion-input tabindex="-1" readonly placeholder="" value={{category_value}}></ion-input>
              </div>
            </ion-col>
          </ion-row>

        </ion-col>
        <ion-col size="6" class="ion-text-center">
          <ng-container *ngIf="plr_value">
            <img src="/assets/images/PLR-A.svg" alt="" class="plr-img" *ngIf="plr_value === 'a'" />
            <img src="/assets/images/PLR-B.svg" alt="" class="plr-img" *ngIf="plr_value === 'b'" />
            <img src="/assets/images/PLR-C.svg" alt="" class="plr-img" *ngIf="plr_value === 'c'" />
            <img src="/assets/images/PLR-D.svg" alt="" class="plr-img" *ngIf="plr_value === 'd'" />
            <img src="/assets/images/PLR-E.svg" alt="" class="plr-img" *ngIf="plr_value === 'e'" />
          </ng-container>
          <ng-container *ngIf="plr_value === ''">
            <img src="/assets/images/PLR-Formula.svg" alt="" class="plr-formulla-img" />
          </ng-container>
        </ion-col>
      </ion-row>

      <!-- Screen 2: Enter PLR Value (NEW) -->
      <ion-row class="content-row" *ngIf="screenMode === 'manual'">
        <ion-col size="12">
          <!-- Row 1: Value Dropdown and Category Input -->
          <ion-row class="cr-row">
            <ion-col size="6">
              <ion-label class="crr-label"> {{ 'Value' | translate}} *</ion-label>
              <div class="crr-ng-bottom-marg">
                <ng-select
                placeholder="{{'select_plr_value' | translate}}"
                 [items]="manualPlrOptions"
                 bindLabel="name"
                 bindValue="val"
                 [(ngModel)]="manualPlrSelection.value"
                  (change)="onManualPlrValueChange($event)">
               </ng-select>
              </div>
            </ion-col>

            <ion-col size="6">
              <ion-label class="crr-label"> {{ 'Category' | translate}}</ion-label>
              <div class="crr-ng-bottom-marg">
                <ion-input tabindex="-1" readonly [(ngModel)]="manualPlrSelection.category" placeholder="{{'Category' | translate}}"></ion-input>
              </div>
            </ion-col>
          </ion-row>

          <!-- Row 2: Description Textarea -->
          <ion-row class="cr-row">
  <ion-col size="12">
              <ion-label class="crr-label"> {{ 'Description' | translate}} *</ion-label>
    <div class="crr-ng-bottom-marg">
      <ion-card class="inner-card-content align">
        <app-ai-writing-field-shell
        #manualDescription="ngModel"
        class="v-space"
         [(ngModel)]="manualPlrSelection.description"
          (ngModelChange)="onManualDescriptionChange()"
          name="manualDescription"
          [maxlength]="2501"
          placeholder="{{ 'Enter Description' | translate }}"
          [rows]="4"
          fieldContextType="plr-description" historyKey="plr-description::manual">
        </app-ai-writing-field-shell>
      </ion-card>
         <div >
          <ion-text class="des-val"  *ngIf="(!manualPlrSelection?.description?.trim()?.length && manualDescriptionFlag)"
            color="danger">
            {{ 'required' | translate }}
          </ion-text>
         </div>
      <div class="char-count-container mar"> 
          <ion-text [ngClass]="{ 'danger': currentManualDescriptionLength > defaultManualDescriptionLength }">
            {{ currentManualDescriptionLength || manualPlrSelection?.description?.length  }}/{{ defaultManualDescriptionLength }}
          </ion-text>
          <ion-text *ngIf="currentManualDescriptionLength > defaultManualDescriptionLength" color="danger">
            {{ 'plr_description_max_length' | translate }}&nbsp;&nbsp;&nbsp;&nbsp;
          </ion-text>
      </div>
       
    </div>
  </ion-col>
</ion-row>
        </ion-col>
      </ion-row>

      <!-- Footer Buttons (Common to both screens) -->
      <ion-row class="button-row">
        <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="cancel()">
          {{'Cancel'|translate}}
        </ion-button>
        <ion-button #submitButton class="app-btn" shape="round" fill="outline" color="primary" (click)="submitPlrValue()" (keydown.tab)="handleSubmitTab($event)">
          {{'Submit'|translate}}
        </ion-button>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>